import { useCallback, useContext, useMemo } from 'react'
import { PrinterContext, ConfigContext } from '@/store'
import useDeviceAuthGrantApi from '@/hooks/useDeviceAuthGrantApi'
import { usePrinterSystemConfig } from '@/hooks/DeviceHttpProxy/usePrinterSystemConfig'

export function usePrinterDetailsApp() {
  const {
    productNumber: localProductNumber,
    setProductNumber,
    deviceCapabilities,
    printerImage
  } = useContext(PrinterContext)
  const { setIsLoading } = useContext(ConfigContext)
  const { handlePrinterDetails } = useDeviceAuthGrantApi()
  const { getProductNumber } = usePrinterSystemConfig()

  const handlePrinterDetailsApp = useCallback(async () => {
    if (!localProductNumber || !deviceCapabilities || !printerImage) {
      setIsLoading(true)
      const productNumber = await getProductNumber()
      // Reusing handlePrinterDetails, but it should be refactored to follow single responsibility
      await handlePrinterDetails(productNumber)
      setIsLoading(false)
      setProductNumber(productNumber)
    }
  }, [
    getProductNumber,
    handlePrinterDetails,
    localProductNumber,
    setProductNumber,
    deviceCapabilities,
    printerImage,
    setIsLoading
  ])

  return useMemo(() => ({ handlePrinterDetailsApp }), [handlePrinterDetailsApp])
}
